import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop.tsx";
import CovidTestKits from "./pages/CovidTestKits.tsx";
import DisposableMasks from "./pages/DisposableMasks.tsx";
import SurfaceWipes from "./pages/SurfaceWipes.tsx";
import HandSanitizer from "./pages/HandSanitizer.tsx";
import NitrileGloves from "./pages/NitrileGloves.tsx";
import AboutUs from "./pages/AboutUs.tsx";
import Contact from "./pages/Contact.tsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";
import TermsOfUse from "./pages/TermsOfUse.tsx";
import TermsOfSale from "./pages/TermsOfSale.tsx";
import FAQ from "./pages/FAQ.tsx";
import { useScrollToTop } from "./hooks/useScrollToTop.ts";

// Import category images
import { RouteTitleUpdater } from "./components/RouteTitleUpdater.tsx";
import Home from "./pages/Home.tsx";
import Header from "./components/Header.tsx";
import Footer from "./components/Footer.tsx";

function AppContent() {
  useScrollToTop();

  return (
    <div className="App">
      <RouteTitleUpdater />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/covid-19-test-kits.html" element={<CovidTestKits />} />
        <Route path="/disposable-masks.html" element={<DisposableMasks />} />
        <Route path="/surface-wipes.html" element={<SurfaceWipes />} />
        <Route path="/hand-sanitizer" element={<HandSanitizer />} />
        <Route path="/nitrile-gloves.html" element={<NitrileGloves />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/terms-of-sales" element={<TermsOfSale />} />
        <Route path="/frequently-asked-questions" element={<FAQ />} />
      </Routes>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
